import { Component, Input } from '@angular/core';
import { ContenutoCorrelato } from '@app/models/data-types/contenuto-correlato';

@Component({
	selector: 'app-contenuti-correlati',
	standalone: true,
	imports: [],
	templateUrl: './contenuti-correlati.component.html',
	styleUrl: './contenuti-correlati.component.css',
})
export class ContenutiCorrelatiComponent {
	@Input() contenutiCorrelati: ContenutoCorrelato[] = [];
}
